export default {
  common: {
    getDataFailed: 'échouer à obtenir les données',
    cancel: 'Annuler',
    noResult: 'Aucun résultat',
    prize: 'primes',
    totalPrize: 'Total des primes',
    round: 'Tour',
    time: 'Temps',
    address: 'Adresse',
    options: 'Options',
    type: 'Type',
    none: 'Aucune',
    executedSuccessfully: 'Mise en œuvre réussie',
  },
  header: {
    referral: 'Recommandation',
    connect: 'Connecter',
    records: 'Mon enregistrement',
    register: 'payer / gager',
    disconnect: 'Déconnecter',
    networkHint: 'Attention à la latence de votre réseau',
  },
  rules: {
    top: "Vous êtes prêt pour le défi? Nous avons 12 questions en total et les gagnants peuvent partager un pool de bonus d'au moins $10,000 au cours d'un tour.",
    title: 'Les règles',
    section1: "La date limite de candidature est 12h00 GMT et l'événement commence à 12h05 GMT.",
    section2: "Vous devez gager Lifeform Avatar et payer 1 BUSD pour vous inscrire à cette activité; Si vous n'avez pas Lifeform Avatar, vous devez payer 20 BUSD pour vous inscrire à cette activité.",
    section3: 'Il y a 12 questions. Pour une question, vous avez 20 secondes pour choisir votre réponse, et la bonne réponse sera affichée dans les 5 secondes restantes. Si vous répondez correctement, passez à la question suivante.',
    section4: 'Une fois ce tour terminé, vous pouvez annuler le gage.',
    section5: 'À la fin de chaque tour, le prix sera remis aux gagnants.',
    section6: "Envoyez un lien recommandé à votre ami pour obtenir une carte de résurrection. [Une fois qu'il / elle aura utilisé votre lien et enregistré l'activité SuperAvatar, vous recevrez la carte de résurrection]",
    section7: "Vous pouvez continuer le jeu avec la carte de résurrection. Chaque carte de résurrection n'offre qu'une chance par tour. ",
    section8: 'Les cartes de résurrection inutilisées expirent automatiquement après chaque tour.',
  },
  home: {
    prizePool: 'Pool de bonus',
    totalParticipants: 'Participants totals',
    round: 'Tour',
    startIn: 'commencer dans',
    connect: 'Connecter',
    register: "S'inscrire",
    registered: 'Enregistré',
    enter: 'Entrer',
    ongoing: 'En cours',
    ended: 'Terminé',
    cumulativeRanking: 'Classement cumulé',
  },
  register: {
    registerRecords: "Dossier d'enregistrement",
    registerForRound: 'Enregistrer le tour',
    youCanChoose: 'Vous pouvez choisir',
    pay: 'Payer',
    or: 'ou',
    stake: 'Gager',
    staked: 'gagé ',
    paid: 'a payé',
    inviteFriends: 'Inviter des amis',
    insufficientFunds: 'Solde insuffisant',
    registerSuccess: 'Inscription réussie',
    registerFail: 'Inscription échouée',
    onceRegistered: "Une fois l'inscription réussie, vous pouvez obtenir le médaillon de SuperAvatar pour ce tour",
    checkMyMedal: 'Regarde mon médaillon',
    backToHome: "Retour à la page d'accueil",
  },
  records: {
    myTotalPrize: 'Mon bonus total',
    myRecordsInSuperAvatar: 'Mon enregistrement sur super Avatar',
    round: 'Tour',
    totalRegistered: 'Participants totals',
    totalPrize: 'Total des primes',
    winners: 'Vainqueur',
    defeat: 'Battre',
    myPrize: 'Mon bonus',
    myRecordsOfPayStake: 'Mon enregistrement de paiement / gage',
  },
  share: {
    share: 'Partager',
    referralUrlCopied: "Connexion à l'invitation copiée",
    showItOff: 'Faites parade',
    invitingYouTo: 'vous invite',
    theWinnersTakeAll: 'Les gagnants partagent tout',
    yourReferralUrl: 'Votre lien recommandé',
    downloadAndShare: 'Télécharger des images et partager',
    comeToWin: 'Venez à super avatar pour obtenir des bonus!',
    iHaveDefeated: "J'ai vaincu ",
    ofThePlayers1: "des joueurs",
    ofThePlayers2: "et j'ai presque obtenu",
    isTheWinnerOfThisRound: 'est le vainqueur de ce tour',
    hasWon: 'Gagné',
    comeToTogether: 'Venez pour gagner plus de bonus ensemble',
    hereRecordOf: 'Voici les enregistrements du jeu de',
    knowMore: 'En savoir plus sur super avatar',
    iHaveWon: 'I HAVE WON',
    everyDay: 'Chaque jour',
    resurrectionCardUsed: 'Carte de résurrection utilisée',
    everyDay12GMTAAnswer: 'Chaque jour à 12h (GMT), répondez correctement à 12 questions et partagez immédiatement 10 000 BUSD à parts égales. Participez au lien :',
    totalHighAs: "Total des primes",
    everyDay12GMT: 'Tous les jours à 12h (GMT)',
    answer12Today1: 'Répondez correctement à 12 questions, les gagnants ',
    answer12Today2: 'se partageront équitablement tout le prix du jour',
    numIHaveDefeated: "J'ai battu",
    numOfThePlayers1: "joueurs",
    numOfThePlayers2: "et j'ai presque eu",
    holdDownShare: "Maintenez la photo à partager",
    win: 'gagner',
  },
  stake: {
    registerByStaking: 'Enregistrer par nantissement',
    unstakeAllAvatar: 'unstake all avatar',
    chooseYourAvatar: 'Choisissez votre avatar',
    stake: 'Gager',
    unstake: 'Annuler le gage',
    unstaked: 'Gage annulé',
    approveToken: "Veuillez autoriser votre municipalité pour l'enregistrement",
    approveNFT: 'Veuillez autoriser votre NFT pour le gage',
  },
  match: {
    watching: 'Au courant de vue',
    sorryYouAreOut: 'Désolé, tu es sorti!',
    wishNext: 'On espère que vous gagnerez à la prochaine!',
    totalPrize: 'Total des primes',
    survivedAndTotal: 'Survivre/Participants totals',
    prizeForEach: 'Bonus pour chacun',
    rememberTo: 'remember to',
    unstakeYourAvatar: 'unstake your avatar',
    congrats: 'Félicitations!',
    areWinner: 'Vous êtes le vainqueur de ce tour.',
    almostWinner: 'Vous êtes presque gagné!',
    keepLearning: 'Continuer à apprendre et passer au prochain tour!',
    toGetCard: 'Pour obtenir la prochaine carte de résurrection',
  },
  referral: {
    currentRound1: "C'est le tour",
    currentRound2: 'maintenant',
    inviteYourFriendsTo: 'Invitez vos amis à obtenir la carte de résurrection pour ce tour!',
    referralRecords: 'Enregistrements recommandés',
    round: 'Tour',
    resurrectionCard: 'Carte de résurrection',
    usedOrNot: 'Utiliser ou non',
    invitedUsers: 'Utilisateurs invités',
    used: 'Utilisé',
    unused: 'Non utilisé',
    none: 'Aucune',
    viewDetails: 'Voir les détails',
  },
};